module.exports = __webpack_public_path__ + "media/theme/SP_top_02-1eb660fd.png";